import React from 'react'
import { UPDATE_THREE_D_MODEL_ERROR, UPDATE_THREE_D_MODEL_STARTING, UPDATE_THREE_D_MODEL_SUCCESS } from '../../../constants/actionTypes';
import { cloneDeep } from 'lodash';
import initialState from '../../../store/initialState';

export default function updateThreeDModel(state = initialState.updateThreeDModel, action) {
    switch (action.type) {
        case UPDATE_THREE_D_MODEL_STARTING: {
            const newState = cloneDeep(state);
            newState.saving = true;
            newState.saved = false;
            return newState;
        }

        case UPDATE_THREE_D_MODEL_SUCCESS: {
            const newState = cloneDeep(state);
            newState.saving = false;
            newState.saved = true;
            newState.error = null;

            return newState;
        }

        case UPDATE_THREE_D_MODEL_ERROR: {
            const newState = cloneDeep(state);
            newState.saving = false;
            newState.saved = false;
            newState.error = action.err;
            return newState;
        }

        default: {
            return state;
        }
    }
}